import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import { ContractStepModel } from '../../../../models/contract.model';
import { STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { TFormState } from '../../../../models/forms.model';
import { IContractDataModel, IRoadMapHistory } from '../../models/contract-internal-models';
import { AlertService } from '../../../../services/notify/alert.service';
import { ContractDataService } from '../../services/contract-data.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, filter, Subscription, switchMap, tap } from 'rxjs';
import { DialogsMTService } from '../../../../services/modal/dialogs-mt.service';
import { FinanceService } from '../../../../services/api/finance.service';
import { MatDialog } from '@angular/material/dialog';
import { AppContractStepCLViewComponent } from '../contract-step-credit-letter-view/contract-step-credit-letter-view.component';
import { ContractAvatarsService } from '../../services/contract-avatar.service';
import { ContractFormService } from '../../services/contract-form.service';
@Component({
    selector: 'app-contract-step-credit-letter',
    templateUrl: './contract-step-credit-letter.component.html',
    styleUrl: './contract-step-credit-letter.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractStepCreditLetterComponent {
    @Input() public contractStep: ContractStepModel|null = null;
    @Input() public contractData: IContractDataModel|null = null;
    private subs:Subscription = new Subscription()
		public CONTRACT_STATUSES_TO_SIGN = ['verified']
    public formState:TFormState = 'Default'
    public stepsStylingMap = STEPS_STYLING_MAP
    public notSingedMembers:string[]|undefined = []
    public singedMembers:string[]|undefined = []
    public stepIsSignedByMember:boolean = false
    public isMemberSigner:boolean = false
    public isRoadMapCurrent:boolean = true
    constructor(
      private cds:ChangeDetectorRef,
      private dialog:MatDialog,
      private alertService:AlertService,
      private translateService:TranslateService,
      private financeService:FinanceService,
      private dialogsMTService:DialogsMTService,
      private contractDataService:ContractDataService,
      public contractAvatarsService:ContractAvatarsService,
      public contractFormService:ContractFormService
    ) { }
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnInit(): void {
      this.subs.add(this.contractDataService.subStepDataChanged.asObservable().subscribe(()=>{
        this.prepareAvatars();
        this.cds.detectChanges();
      }))
    }
    ngOnChanges(): void {
      let currentRoadMapGuid = (this.contractDataService.subRoadMapSelected.value as IRoadMapHistory)?.roadmap?.guid
      this.isRoadMapCurrent = currentRoadMapGuid? this.contractData?.contract?.roadmap_active?.guid === currentRoadMapGuid : true
      let signatories = this.contractStep!.target?.payer_project?.members?.signatories||[]
      this.contractStep!.target?.payer_private?.member ? signatories = [{
            member: this.contractStep!.target.payer_private.member,
            can_verify: true,
            verified_at: '',
        }] : null;
      this.isMemberSigner = signatories.filter(el=>el.member.guid === this.contractDataService.currentMember?.guid).length > 0
			this.contractData?.contract?.contract.status
      this.notSingedMembers = this.contractStep?.membersAvatarsToShow?.filter(el=>el.state===false).map(el=>el.guid)
      this.singedMembers = this.contractStep?.membersAvatarsToShow?.filter(el=>el.state===true).map(el=>el.guid)
      this.stepIsSignedByMember = this.singedMembers?.includes(this.contractDataService.currentMember?.guid||'') || false
    }
    prepareAvatars() {
      this.notSingedMembers = this.contractStep?.membersAvatarsToShow?.filter(el=>el.state===false).map(el=>el.guid)
      this.singedMembers = this.contractStep?.membersAvatarsToShow?.filter(el=>el.state===true).map(el=>el.guid)
    }
    signCreditLetter(){
      let creditLetterGuid = this.contractStep!.target?.payer_project?.credit_letter_guid ||
			this.contractStep!.target?.payer_private?.credit_letter_guid || '';
			let contractGuid =  this.contractData?.contract?.contract.guid
			if (!creditLetterGuid && contractGuid) {
				return this.alertService.setAlert('Невозможно провести операцию. Отсутствует номер контракта или обеспечения', 'blue');
			}
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        this.formState = 'Submitting';
        let pinMessage = this.translateService.instant(this.stepIsSignedByMember ? 'MODALS.HEADERS.RECALL_CREDIT_LETTER' : 'MODALS.HEADERS.SIGN_CREDIT_LETTER' );

        this.dialogsMTService.openPinDialog(!this.stepIsSignedByMember,pinMessage).pipe(
          tap(res=>!res?.pin? this.changeFormState('Default') :null),
          filter(res => res.pin !== null),
          switchMap(pin =>this.financeService.signOnOffCreditLetter(creditLetterGuid, pin.pin.toString(), !this.stepIsSignedByMember, contractGuid!).pipe(
            catchError(e => {
              this.alertService.setAlert(e.message, 'blue');
              this.changeFormState('Default')
              return EMPTY
            }))),
          tap(data=>this.changeSignedStatus()),
          tap((data)=>this.alertService.setAlert(data?.message, 'nd_color')),
          tap(()=>this.contractDataService.subStepDataChanged.next({
              stepName:this.contractStep?.name||this.contractStep?.auto_name||'',
              step:this.contractStep!
            })),
          tap(()=>this.changeFormState('Default')),
          catchError(() => {
            this.formState ='Default'
            return EMPTY
          })).subscribe()
      })
    }
    changeSignedStatus() {
      if (this.stepIsSignedByMember) {
        let ind = this.contractStep?.members_signed_step?.findIndex(el=>el.member_guid===this.contractDataService.currentMember?.guid)
        ind!==undefined&&ind>=0? this.contractStep?.members_signed_step?.splice(ind,1) : null
      } else {
        this.contractStep?.members_signed_step?.push({created_at:new Date().toISOString(),member_guid:this.contractDataService.currentMember!.guid})
      }
      this.stepIsSignedByMember = !this.stepIsSignedByMember
      let avatar = this.contractStep?.membersAvatarsToShow?.find(el=>el.guid === this.contractDataService.currentMember?.guid||'')
      avatar? avatar.state = !avatar.state : null;
      this.prepareAvatars()
    }
    changeFormState(state:TFormState) {
      this.formState = state
      this.cds.detectChanges()
      this.contractData?.contract?.roadmap_active.guid
    }
    viewCreditLetter(){
      if (this.contractStep?.target_key&&this.contractStep) {
        let paymentViweRef = this.dialog.open(AppContractStepCLViewComponent,{
          panelClass:'payment-edit-dialog-box',
          width:'468px',
          height:'520px'
        })
        paymentViweRef.componentInstance.clStep = this.contractStep 
        paymentViweRef.componentInstance.contractParties = this.contractData?.contract?.projects!

      }
    }
}